import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AccessibilityState } from './accessibility.state';
import { Observable } from 'rxjs';
import { HighContrastMode } from '../services/models/accesibility.model';
import { EnableHighContrast, SetHighContrastMode } from './accessibility.actions';

@Injectable({ providedIn: 'root' })
export class AccessibilityFacade {
  private readonly store = inject(Store);

  @Select(AccessibilityState.highContrastMode) highContrastMode$: Observable<HighContrastMode>;
  @Select(AccessibilityState.highContrastEnabled) highContrastEnabled$: Observable<boolean>;

  get highContrastMode() {
    return this.store.selectSnapshot(AccessibilityState.highContrastMode);
  }

  get highContrastEnabled() {
    return this.store.selectSnapshot(AccessibilityState.highContrastEnabled);
  }

  setHighContrastEnabled(enabled: boolean) {
    this.store.dispatch(new EnableHighContrast(enabled));
  }

  setHighContrastMode(mode: HighContrastMode) {
    this.store.dispatch(new SetHighContrastMode(mode));
  }
}
